import React from 'react'
import Title from './../../../../components/typography/title.component'
import Button from '../../../../components/buttons/buttons.component'
import Container from '../../../../components/layout/container.component'
import ModalConfirmation from './../../../../components/modal/modal-confirmation.component'
import { Formik, Form } from 'formik'
import { routes } from '../../../../constants/routes.constants'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { toastActions, userActions } from '../../../../actions'
import { setUserPermissions } from '../../../../helpers'
import { bindActionCreators } from 'redux'
import { updateClientActions } from './update-client.actions'
import { Creators as SiteCreators } from '../../../../ducks/site/site'
import { StyledButtons, StyledUpdate } from './styles.style'
import { FormItemsComponent, getSchema } from './update-client.functions'
import { MuvicardAdminService } from '../../../../services/muvicard-admin.service'
import { AuthenticationService } from '../../../../services/authentication.service'
import { BenefitsService } from '../../../../services/benefits.service'
import { TextAreaInput } from '../../../../components/form-components'
import { AdminService } from '../../../../services/admin.service'
import { StorageService, MuvicardService } from '../../../../services'
import { RoleConstants } from '../../../../constants'
import { parseJwt } from '@helpers'

class UpdateClientInformationPageComponent extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			loading: true,
			modalIsOpen: false,
			modalWithReasonIsOpen: false,
			modalSimulationIsOpen: false,
			cardInformations: null,
			needReason: false,
			benefitsOptions: [],
			caregiverOptions: []
		}

		this.initialValues = {
			name: '',
			cpf: '',
			moveflexNumber: '',
			rg: '',
			email: '',
			birthday: '',
			gender: '',
			phone: '',
			subscribedToNewsletter: false,
			active: false,
			antifraud: true,
			serviceCharge: true,
			status: '',
			originalLimitValue: 0,
			cnpj: '',
			stateRegistration: '',
			companyName: '',
			companyTradingName: '',
			benefitActive: true,
			benefitCode: '',
			benefitTypeId: '',
			expiryDate: '',
			caregiver: ''
		}

		this.loadCargiverOptions = this.loadCargiverOptions.bind(this)
	}

	componentWillMount() {
		const { showLoading, match, getClientById } = this.props

		showLoading()

		getClientById(match.params.id)

		this.fetchBenefitsTypes()
	}

	mapOptions = options =>
		options.map(({ userId, data }) => ({
			value: userId,
			label: data
		}))

	loadOptions = async inputValue => {
		const { data } = await AdminService.searchUsersByName(inputValue)

		const options = this.mapOptions(data)

		this.setState({
			caregiverOptions: options
		})

		return options
	}

	loadCargiverOptions = (inputValue, callback) => {
		if (this.previousInputValue === inputValue) return

		this.previousInputValue = inputValue

		if (inputValue) {
			this.loadOptions(inputValue).then(data =>
				callback(data.length ? [].concat(data) : null)
			)
		}
	}

	fetchBenefitsTypes = async () => {
		try {
			const response = await BenefitsService.GetBenefitsTypes()
			if (response.success && response.data) {
				const benefitsOptions = response.data.map(benefit => ({
					value: benefit.id,
					label: benefit.type,
					isCaregiverRequired: benefit.caregiverRequired
				}))
				this.setState({ benefitsOptions })
			} else {
				throw new Error('Falha ao buscar tipos de benefícios')
			}
		} catch (error) {
			console.error('Erro ao buscar benefícios:', error)
		}
	}

	componentWillReceiveProps(nextProps) {
		const { errors, isFetching, isUpdating } = this.props
		const withNoErrors = !errors || !errors.length
		const clientUpdated = !nextProps.isUpdating && isUpdating
		const alreadyFetched = isFetching && !nextProps.isFetching

		if (clientUpdated && withNoErrors) {
			goToClientSearch.call(this)
		}

		if (alreadyFetched) {
			this.initialValues = Object.$flat(nextProps.client)
			this.setState({ loading: false })
		}

		if (nextProps.client) {
			const { caregiver } = nextProps.client.benefitsData

			if (caregiver) {
				const { name, userId } = caregiver

				if (name) {
					this.loadOptions(name)
				}
			}
		}
	}

	componentDidMount() {
		this.props.hideLoading()

		const { user } = this.props

		setUserPermissions(user)

		const userId = this.props.match.params.id

		MuvicardAdminService.searchForCard(userId)
			.then(response => {
				if (response.success) {
					this.setState({
						cardInformations: response.data
					})
				}
			})
			.catch()
	}

	submit = (values, { setFieldValue }) => {
		const { match, client } = this.props
		const { cardInformations } = this.state

		const name = (values.name || '').trim().replace(/\s+/g, ' ')
		setFieldValue('name', name)

		const caregiverUserId = values.caregiver
			? values.caregiver.userId || values.caregiver
			: null

		this.values = {
			...values,
			addresses: client.addresses,
			identityUserId: match.params.id,
			cardStatus: values.status,
			newLimit: values.limitValue,
			cardStatusReason: '',
			caregiverUserId
		}

		if (
			cardInformations &&
			status &&
			(cardInformations.status === 'Ativo' ||
				cardInformations.status == 'Bloqueado') &&
			(status === 'Cancelado' || status === 'Inativo')
		) {
			this.setState({ modalWithReasonIsOpen: true, needReason: true })
		} else {
			this.setState({ modalIsOpen: true, needReason: false })
		}
	}

	onResult = confirmed => {
		if (confirmed) {
			const { updateClient } = this.props

			if (this.state.needReason) {
				this.values.cardStatusReason = CardStatusReason.value
			}

			updateClient(this.values)
		}
		this.setState({ modalIsOpen: false, modalWithReasonIsOpen: false })
	}

	render() {
		const {
			history,
			client,
			match,
			user,
			userLogin,
			showLoading,
			hideLoading
		} = this.props

		const {
			loading,
			modalIsOpen,
			modalWithReasonIsOpen,
			cardInformations,
			benefitsOptions
		} = this.state

		// TODO: Implementar função para mostar cargiver existente

		return (
			<Container small>
				<Title>Alteração de dados do cliente</Title>
				{loading || !client ? null : (
					<StyledUpdate>
						<Formik
							ref={'form'}
							initialValues={this.initialValues}
							onSubmit={this.submit}
							validationSchema={getSchema()}
							render={props => {
								return (
									<FormComponent
										addresses={client.addresses}
										client={client}
										match={match}
										benefitsOptions={benefitsOptions}
										user={user}
										cardInformations={cardInformations}
										onChangeAddress={() =>
											this.setState({
												changeAddressModalIsOpen: true
											})
										}
										history={history}
										formikRef={this.refs.form}
										userLogin={userLogin}
										setAccessToken={this.props.setAccessToken}
										showLoading={showLoading}
										hideLoading={hideLoading}
										loadCargiverOptions={this.loadCargiverOptions}
										caregiverOptions={this.state.caregiverOptions}
										{...props}
									/>
								)
							}}
						/>
					</StyledUpdate>
				)}

				<ModalConfirmation
					isOpen={modalWithReasonIsOpen}
					title={'Salvar'}
					onResult={this.onResult}>
					Confirmar a atualização dos dados do cliente?
					<hr />
					<Formik
						initialValues={{ CardStatusReason: '' }}
						render={props => (
							<form noValidate onSubmit={props.handleSubmit}>
								<TextAreaInput
									label={'Motivo da alteração de status do Muvicard*'}
									className={'col-12'}
									id={'CardStatusReason'}
									rows={'3'}
									{...props}
								/>
							</form>
						)}
					/>
				</ModalConfirmation>
				<ModalConfirmation
					isOpen={modalIsOpen}
					title={'Salvar'}
					onResult={this.onResult}>
					Confirmar a atualização dos dados do cliente?
					{this.cardInformations &&
						this.values.cardStatus !== undefined &&
						this.values.cardStatus !== this.cardInformations.status && (
							<React.Fragment>
								<p>Motivo da alteração do Status</p>
								<Formik
									initialValues={{ reason: '' }}
									render={props => (
										<form noValidate onSubmit={props.handleSubmit}>
											<textarea
												autoComplete="off"
												name="reason"
												id="reason"
												onBlur={props.handleBlur}
												onChange={props.handleChange}
											/>
										</form>
									)}
								/>
							</React.Fragment>
						)}
				</ModalConfirmation>
			</Container>
		)
	}
}

class FormComponent extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			modalIsOpen: false
		}

		this.formReferences = {
			activeRef: React.createRef(),
			nameRef: React.createRef(),
			rgRef: React.createRef(),
			emailRef: React.createRef(),
			birthdayRef: React.createRef(),
			phoneRef: React.createRef(),
			statusRef: React.createRef(),
			originalLimitValueRef: React.createRef(),
			cnpjRef: React.createRef(),
			stateRegistrationRef: React.createRef(),
			companyNameRef: React.createRef(),
			companyTradingNameRef: React.createRef(),
			benefitActiveRef: React.createRef(),
			benefitTypeIdRef: React.createRef(),
			benefitCodeRef: React.createRef(),
			benefitExpiryDateRef: React.createRef(),
			caregiverRef: React.createRef()
		}
	}

	getConfirmation = () => {
		this.setState({
			modalIsOpen: true
		})
	}

	getSimulationConfirmation = () => {
		this.setState({
			modalSimulationIsOpen: true
		})
	}

	cancel = () => {
		const { history } = this.props
		history.push(`${routes.ADMIN}/clientes`)
	}

	clientSimulate = async () => {
		const { showLoading, hideLoading, match, userLogin, history } = this.props

		showLoading()

		const { data, success } = await AuthenticationService.clientSimulate(
			match.params.id
		)

		let user = data

		if (success) {
			userLogin(user)

			history.push('/')
		}

		hideLoading()
	}

	onResult = confirmed => {
		this.setState({ modalIsOpen: false })
		if (confirmed) {
			this.cancel()
		}
	}

	onSimulationResult = confirmed => {
		this.setState({ modalSimulationIsOpen: false })
		if (confirmed) {
			this.clientSimulate()
		}
	}

	submit = () => {
		if (!this.props.isValid) {
			const id = Object.keys(this.props.errors)[0]
			const ref = this.formReferences[`${id}Ref`]
			if (!ref || !ref.current) return
			ref.current.focus()
		}
	}

	render() {
		const { modalIsOpen, modalSimulationIsOpen } = this.state
		const { handleSubmit, values, match } = this.props

		return (
			<Form noValidate onSubmit={handleSubmit}>
				<FormItemsComponent
					{...this.formReferences}
					match={match}
					values={values}
					{...this.props}
				/>
				<StyledButtons className="buttons">
					<Button
						data-permission="EA727575D94FD5C1B209110F32F6A92ABECE6149"
						primary
						type="submit"
						onClick={this.submit}>
						Salvar
					</Button>
					<Button danger type="button" onClick={this.getConfirmation}>
						Cancelar
					</Button>
					<Button
						data-permission="ADC5B9EC793F85D935D6C3047B289578270C7EBF"
						secondary
						type="button"
						onClick={this.getSimulationConfirmation}>
						Simular cliente
					</Button>
				</StyledButtons>
				<ModalConfirmation
					isOpen={modalIsOpen}
					title={'Cancelar'}
					onResult={this.onResult}>
					Você tem certeza que deseja cancelar a operação? <br /> Todos os
					dados alterados serão descartados
				</ModalConfirmation>
				<ModalConfirmation
					isOpen={modalSimulationIsOpen}
					title={'Simular Cliente'}
					onResult={this.onSimulationResult}>
					Todas as ações serão realizadas no login do cliente. Continuar?
				</ModalConfirmation>
			</Form>
		)
	}
}

function goToClientSearch() {
	this.props.history.push(`${routes.ADMIN}/clientes`)
}

const mapStateToProps = ({ updateClientInfo, user }) => {
	return {
		...updateClientInfo,
		user
	}
}

const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{
			...toastActions,
			...SiteCreators,
			...updateClientActions,
			userLogin: userActions.login,
			setAccessToken: userActions.setAccessToken
		},
		dispatch
	)

const connectedUpdateClientInformationPageComponent = withRouter(
	connect(
		mapStateToProps,
		mapDispatchToProps
	)(UpdateClientInformationPageComponent)
)

export { connectedUpdateClientInformationPageComponent as ModuleRootComponent }
